<script>
import {getMobileSettingInfo, getSettingItem, getTerminateSettingInfo, setSystemSettingInfo} from "@/api/setting-api";
import {getAllArea} from "@/api/device-manager-api";

export default {
  name: "LauncherOtherSettingView",
  data() {
    return {
      target: "LANGUAGE_EN",
      type: "GENERAL_FIELD",

      settings: {
        welcome: {},
        systemName: {},
      },
      chineseConfig: {
        welcome: {},
        systemName: {},
      },

      tableListH5: [],
      tableListMachine: [],
      activeName: "first",

    }
  },
  mounted() {

    this.tableListMachine.push({id: "-1", pName: "默认", subName: "默认", subAddr: "默认", tableDataLevel2: [{id: "default", type: "systemName",}, {id: "default", type: "welcome"},]})
    getAllArea().then(({data}) => {
      console.log("getAllArea", data)
      if (data.code === 200) {
        this.areaTree = data.data
        this.areaTree.forEach((item) => {
          ;(item.areas || []).forEach((child) => {
            this.tableListMachine.push({
              id: child.id,
              pName: item.name,
              subName: child.name,
              subAddr: child.address,
              tableDataLevel2: [
                {id: child.id, type: "systemName",},
                {id: child.id, type: "welcome"},
              ]
            })
          })
        })
      }
    }).catch((err) => {
      console.log("getAllArea err", err)
    })
    this.setupPage()
  },

  methods: {
    setupPage() {
      getSettingItem(this.target, this.type).then(({data}) => {
        console.log("other setting getSettingItem", data)
        if (data.code === 200 && data.data.length > 0) {
          let setting = data.data[0]
          this.settings = JSON.parse(setting.content)
        }
        console.log("settings @@@@@ ", this.settings)
        this.$refs.tableH5.doLayout()

      }).catch((err) => {
        console.log("getSettingItem err", err)
      })

      getMobileSettingInfo().then(({data}) => {
        console.log("getMobileSettingInfo", data)
        if (data.code === 200) {
          data.data.forEach(item => {
            switch (item.type) {
              case "SYSTEM_NAME":
                this.chineseConfig.systemName.h5 = item.content
                break
              case "HOME_WELCOME":
                this.chineseConfig.welcome.h5 = item.content
                break
            }
          })
        } else {
          console.log("getMobileSettingInfo false", data.msg)
          this.showServerErrMsg(data.msg)
        }
        this.tableListH5 = [
          {id: "h5", type: "systemName"},
          {id: "h5", type: "welcome",},
        ]
      }).catch(err => {
        console.error("getMobileSettingInfo err", err)
        this.showNetErrMsg()
        this.tableListH5 = [
          {id: "h5", type: "systemName"},
          {id: "h5", type: "welcome",},
        ]
      })

      getTerminateSettingInfo().then(({data}) => {
        console.log("getMobileSettingInfo", data)
        if (data.code === 200) {
          data.data.forEach(item => {
            switch (item.type) {
              case "SYSTEM_NAME": {
                let content = JSON.parse(item.content);
                console.log("SYSTEM_NAME content", content)
                Object.keys(content).forEach(key => {
                  this.chineseConfig.systemName[key] = content[key].ctn
                })
                break
              }
              case "HOME_WELCOME": {
                let content = JSON.parse(item.content);
                console.log("HOME_WELCOME content", content)
                Object.keys(content).forEach(key => {
                  this.chineseConfig.welcome[key] = content[key].ctn
                })
                break
              }
            }
          })
        } else {
          console.log("getMobileSettingInfo false", data.msg)
          this.showServerErrMsg(data.msg)
        }
        console.log("chineseConfig @@@@@ ", this.chineseConfig)
      }).catch(err => {
        console.error("getMobileSettingInfo err", err)
        this.showNetErrMsg()
      })
    },


    saveAreaSetting() {
      let content = JSON.stringify(this.settings)
      let setting = {
        target: this.target,
        type: this.type,
        content: content,
        state: "VALID"
      }
      setSystemSettingInfo(setting).then(({data}) => {
        console.log("setSystemSettingInfo", data)
        if (data.code === 200) {
          this.$message.success("保存成功")
        } else {
          this.$message.error("保存失败")
        }
      }).catch((err) => {
        console.log("setSystemSettingInfo err", err)
      })
    },


  }, // methods
}
</script>

<template>
  <div>
    <div class="nav">
      <el-radio-group v-model="activeName">
        <el-radio-button class="nav-item" label="first" border>移动端</el-radio-button>
        <el-radio-button class="nav-item grayBg" label="second" border>访客机</el-radio-button>
      </el-radio-group>
    </div>
    <div class="h-4"></div>
    <el-table ref="tableH5" :data="tableListH5" stripe border v-if="activeName === 'first'" key="1">
      <el-table-column prop="type" label="字段类型">
        <template slot-scope="scope">
          {{ scope.row.type === "welcome" ? "单位欢迎词" : "系统名称" }}
        </template>
      </el-table-column>
      <el-table-column label="中文内容">
        <template slot-scope="scope">
          {{ chineseConfig[scope.row.type][scope.row.id] }}
        </template>
      </el-table-column>
      <el-table-column label="英文内容">
        <template slot-scope="scope">
          <el-input v-model="settings[scope.row.type][scope.row.id]"></el-input>
        </template>
      </el-table-column>
    </el-table>
    <el-table ref="tableMachine" :data="tableListMachine" stripe border v-else key="2">
      <el-table-column type="expand">
        <template slot-scope="scope">
          <el-table :data="scope.row.tableDataLevel2" stripe border size="small" class="ml-12">
            <el-table-column prop="type" label="字段类型">
              <template slot-scope="subScope">
                {{ subScope.row.type === "welcome" ? "单位欢迎词" : "系统名称" }}
              </template>
            </el-table-column>
            <el-table-column label="中文内容">
              <template slot-scope="subScope">
                {{ chineseConfig[subScope.row.type][scope.row.id]}}
              </template>
            </el-table-column>
            <el-table-column label="英文内容">
              <template slot-scope="subScope">
                <el-input v-model="settings[subScope.row.type][scope.row.id]"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="pName" label="父区域"></el-table-column>
      <el-table-column prop="subName" label="子区域"></el-table-column>
      <el-table-column prop="subAddr" label="子区域地址"></el-table-column>
    </el-table>
    <div class="p-4 text-center" style="width: 80%">
      <el-button class="w-40" type="primary" @click="saveAreaSetting">保存</el-button>
    </div>


  </div>
</template>

<style scoped lang="less">
.nav {
  //padding-left: 10px;
  //padding-bottom: 10px;
  //background-color: #efefef;

  .nav-item {
    margin-right: 15px;
  }
}

//.grayBg {
//
//}

/deep/ .el-radio-button__inner {
  background-color: #efefef;
}

::v-deep .el-radio-button:first-child .el-radio-button__inner {
  border-radius: 60px;

}

::v-deep .el-radio-button:last-child .el-radio-button__inner {
  border-radius: 60px;
}
</style>
